var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d2-page-cover"},[_c('div',{staticClass:"d2-page-cover__logo"},[_vm._t("default")],2),_c('p',{staticClass:"d2-page-cover__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"d2-page-cover__sub-title d2-mt-0"},[_vm._v(_vm._s(_vm.subTitle))]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }